

import React, { useContext, useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import styled from "styled-components";
import { AppContext } from "../../../contexts/AppContext";
import { useAgents } from "../../../contexts/AgentsContext";


const EditAgentSidebarWrapper = styled.div`
  width: 250px;
  background-color: var(--sidebar-bg);
  border: 1px solid var(--sidebar-border-color);
  box-sizing: content-box;
  margin-left: -20px;
  margin-top: -40px;
  z-index: 1;

  height: auto;
  position:sticky;
`;

const EditAgentSidebarInnerWrapper = styled.div`
  width: 250px;
  overflow: hidden auto;
  height: 100vh;
  padding: 20px 16px 8px 16px;
  display: flex;
  flex-direction: column;
  position: fixed;
`;

const EditAgentSidebarItems = styled.div`
  margin-top: 20px;
`;

const EditAgentSidebarItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  padding: 13px 5px 13px 10px;
  border-radius: 8px;
  cursor: pointer;

  &.active {
    background-color: var(--sidebar-active-item-bg);
  }

  &.active  * {
    color: var(--sidebar-active-item-color) !important;
  }

  &:hover:not(.active) {
    background-color: var(--sidebar-active-item-bg);
  }
`;

const EditAgentSidebarItemText = styled.span`
  font-size: 16px;
  font-weight: 300;
  color: var(--sidebar-item-color);
  padding-left: 10px;
`;

const EditAgentSidebarItemIcon = styled(Icon)`
  font-size: 18px;
  color: var(--sidebar-item-color);
`;

export const EditAgentSidebar = ({
  show = true,
  defaultSelectedTab = window.location.hash ? window.location.hash.substr(1) : "details",
  onNavItemClicked = () => { },
  onToggle = () => { },
}) => {
  console.log("!!! DEFAULT SELECTED TAB: ", defaultSelectedTab)
  const { selectedAgent } = useAgents();
  const [selectedTab, setSelectedTab] = useState(defaultSelectedTab);
  const { selectedClient } = useContext(
    AppContext
  );
  console.log("!!! SIDEBAR SELECTED CLIENT: ", selectedClient)

  useEffect(() => {
    setSelectedTab(defaultSelectedTab);
  }, [defaultSelectedTab]);

  useEffect(() => {
    window.history.pushState(null, null, `#${selectedTab}`);
    onNavItemClicked(selectedTab);

    // eslint-disable-next-line
  }, [selectedTab]);

  const selectTab = (tab) => {
    setSelectedTab(tab);
    // Update to use the has of the tab
  };

  const isSelected = (tab) => {
    console.log("!!! CHECKING IF SELECTED: ", tab, selectedTab, selectedTab === tab);
    return selectedTab === tab ? "active" : "";
  }


  return (
    <EditAgentSidebarWrapper
      style={{
        width: show ? "250px" : "24px",
        transition: "width 0.3s ease-in-out",
        height: "100vh",
        marginTop: "-20px",
      }}
    >
      <button
        onClick={() => {
          onToggle();
        }}
        style={{
          width: "24px",
          height: "40px",
          backgroundColor: "var(--sidebar-active-item-bg)",
          color: "var(--sidebar-active-item-color)",
          borderTopRightRadius: ".25rem",
          borderBottomRightRadius: ".25rem",
          outline: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: "50%",
          right: "-24px",
          zIndex: 1,
          border: "none",
          cursor: "pointer",
          fontSize: "20px",
        }}
      >
        <i className="fas fa-ellipsis-v"></i>
      </button>
      <EditAgentSidebarInnerWrapper
        style={{ display: show ? "flex" : "none" }}
      >
        <EditAgentSidebarItems style={{ flexGrow: 0 }}>
          <EditAgentSidebarItem className={isSelected("details")} onClick={() => selectTab("details")}>
            <span>
              <EditAgentSidebarItemIcon icon="lucide:info" />
            </span>
            <EditAgentSidebarItemText>Details</EditAgentSidebarItemText>
          </EditAgentSidebarItem>
          <EditAgentSidebarItem className={isSelected("workflow-graph")} onClick={() => selectTab("workflow-graph")}>
            <span>
              <EditAgentSidebarItemIcon icon="lucide:bot" />
            </span>
            <EditAgentSidebarItemText>Agent Workflow</EditAgentSidebarItemText>
          </EditAgentSidebarItem>

          <EditAgentSidebarItem
            className={isSelected("dynamic-workflow")}
            onClick={() => selectTab("dynamic-workflow")}
            title="Edit this agent's graph with the new dynamic nodes"
          >
            <span>
              <EditAgentSidebarItemIcon icon="lucide:square-arrow-out-up-right" />
            </span>
            <EditAgentSidebarItemText>Dynamic Graph</EditAgentSidebarItemText>
          </EditAgentSidebarItem>

          {selectedAgent?.public_id && (
            <EditAgentSidebarItem className={isSelected("chat-sessions")} onClick={() => selectTab("chat-sessions")}>
              <span>
                <EditAgentSidebarItemIcon icon="lucide:files" />
              </span>
              <EditAgentSidebarItemText>Chat Sessions</EditAgentSidebarItemText>
            </EditAgentSidebarItem>
          )}
        </EditAgentSidebarItems>
      </EditAgentSidebarInnerWrapper>
    </EditAgentSidebarWrapper>
  );
};

export default EditAgentSidebar;
